import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { NotificationsService } from "src/app/Services/notifications.service";
import { ReactivityService } from "src/app/Services/reactivity.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "app-wallet-list-menu",
    templateUrl: "./wallet-list-menu.component.html",
    styleUrls: ["./wallet-list-menu.component.scss"],
})
export class WalletListMenuComponent implements OnInit {
    @Input() lang: any;
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;
    currency = this.embryoService.currency;
    clonedProducts: Array<any> = [];
    enteredMenu: boolean = false;
    isMobile: any;
    environmentVariables: any;
    headerIconsColor: any;
    user: any;
     changeIconFill:boolean = true;

    constructor(
        private embryoService: EmbryoService,
        private auth: LoginUsersService,
        private pagesService: StaticPagesService,
        private router: Router
    ) {
        this.auth.userEmit.subscribe((data) => {
            if (data) {
                this.user = data;
            }
        });
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
            this.headerIconsColor =
                this.environmentVariables.HEADER_ICONS_FILL_COLOR;
        });
    }

    ngOnInit() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent
        );
    }

    toggleMenu(event: any, open: any) {
        if (!this.isMobile) {
            if (open) {
                event.stopPropagation();
                this.enteredMenu = false;
                this.menuTrigger.openMenu();
            } else {
                setTimeout(() => {
                    if (!this.enteredMenu) {
                        this.menuTrigger.closeMenu();
                    }
                }, 150);
            }
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }

    checkUserGuest() {
        this.router.navigate(["/" + this.lang + "/account/wallet-history"]);
    }
}
